import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { LoanYearsSelect } from "../../Utils/CustomComponent";
import { useDispatch, useSelector } from "react-redux";
import { fetchLoanValue } from "../../store/reducers/submitALoanSlice/api";
import { useAbortController } from "../../hooks/useAbortController";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const finalLabel = [
  { title: "Jan", field: 1 },
  { title: "Feb", field: 2 },
  { title: "Mar", field: 3 },
  { title: "Apr", field: 4 },
  { title: "May", field: 5 },
  { title: "Jun", field: 6 },
  { title: "Jul", field: 7 },
  { title: "Aug", field: 8 },
  { title: "Sep", field: 9 },
  { title: "Oct", field: 10 },
  { title: "Nov", field: 11 },
  { title: "Dec", field: 12 },
];

export default function QuickBarChartLoanValue() {
  const { signal } = useAbortController();
  const dispatch = useDispatch();
  const [loanYearSelect, setLoanYearSelect] = useState([]);
  const loanValueStatus = useSelector(
    (state) => state.submitALoan.loanValues.status
  );
  const loanValue = useSelector(
    (state) => state.submitALoan.loanValues.loanValue
  );
  const loanYears = useSelector(
    (state) => state.submitALoan.loanValues.loanYears
  );
  const lenderId = useSelector((state) => state.account.lenderId);
  useEffect(() => {
    dispatch(fetchLoanValue({ lenderId, signal }));
  }, [dispatch, lenderId]);
  useEffect(() => {
    setLoanYearSelect(loanYears[0]);
  }, [loanYears]);

  const labels = finalLabel?.map((label) => label.title);
  const barData = {
    labels,
    datasets: [
      {
        data: loanValue[loanYearSelect],
        backgroundColor: "#438FFE",
        barThickness: 10,
        borderRadius: 10,
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: false,
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "Loan Value in $",
        },
        grid: {
          display: false,
        },
      },
      x: {
        title: {
          display: true,
          text: `Year ${loanYearSelect}`,
        },
        grid: {
          display: false,
        },
      },
    },
  };
  return (
    <>
      {loanValueStatus === "fulfilled" ? (
        <>
          <div className="d-flex justify-content-between flex-row">
            <h5>Loan Value</h5>
            <LoanYearsSelect
              loanYears={loanYears}
              loanYearSelect={loanYearSelect}
              setLoanYearSelect={setLoanYearSelect}
            />
          </div>
          <div className="">
            <Bar options={options} data={barData} />
          </div>{" "}
        </>
      ) : null}
    </>
  );
}
